<template>
  <div id="app">
    <router-view />
    <announcementTip />
  </div>
</template>

<script>
import announcementTip from '@/components/home/announcementTip.vue'
export default {
  name: 'App',
  components: {
    announcementTip
  }
}
</script>

<style>
html,body{
     height: 100%;
}
#app {
  font-family: 'Microsoft Yahei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue